module.exports = __webpack_public_path__ + "static/media/bg-login.58d2e715.svg";